import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-black text-white">
      <h1 className="text-7xl font-bold mb-4">404</h1>
      <p className="text-lg mb-6 text-gray-400">
        Page not found
      </p>

      <button
        onClick={() => navigate("/")}
        className="border border-white px-6 py-2 rounded-lg hover:bg-white hover:text-black transition"
      >
        Go Home
      </button>
    </div>
  );
}